import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import LetsBeginYourStory from "./sections/LetsBeginYourStory";
import TheSleepGap from "./sections/TheSleepGap";
import WhyTreatmentMatters from "./sections/WhyTreatmentMatters";
import DfwNeighborhoodTrust from "./sections/DfwNeighborhoodTrust";
import StartYourTransformation from "./sections/StartYourTransformation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <LetsBeginYourStory />
      <TheSleepGap />
      <WhyTreatmentMatters />
      <DfwNeighborhoodTrust />
      <StartYourTransformation />
      <Footer />
    </div>;
}